import { createFileRoute } from '@tanstack/react-router';

import { HistoryView } from '@/features/subscriber/HistoryView';

export const Route = createFileRoute('/subscriber/history/watching')({
  component: () => <HistoryView kind="video" />,
});
